import React, { Component } from 'react';
//import logoImage from 'assets/img/icons/logo.png';
import { userActions } from 'redux/_actions';
import { connect } from 'react-redux';
import { t } from "i18next";
import { Input, Button, Spinner } from 'reactstrap';
import { 
    MdCheckBox, 
    MdCheckBoxOutlineBlank 
} from 'react-icons/md';

export const STATE_LOGIN = 'LOGIN';
export const STATE_SIGNUP = 'SIGNUP';
export const STATE_FORGOT = 'FORGOT';

class AuthForm extends Component {

    constructor(props) {
        super(props)
        this.state = {
            authState: STATE_LOGIN
        }
    }

    componentDidUpdate(prevProps) {
        const {resetSuccess, loggingIn, user, onClickClose} = this.props;
        if (prevProps.resetSuccess == null && resetSuccess != null) {
            alert(t(resetSuccess ? 'reset_password_success' : 'reset_password_failure'));
            return;
        }
        if (prevProps.loggingIn === true && loggingIn === false) {
            alert(t(user ? 'auth_success' : 'auth_failure'));
            if (user && onClickClose) {
                onClickClose();
            }
            return; 
        }
    }

    onAuthAction() {
        const {authState, username, email, password, retype} = this.state;

        if (authState === STATE_SIGNUP && (!username || username.length < 1)) {
            alert(t('input_username_prompt'));
            return;
        }
        if (!email || email.length < 3) {
            alert(t('input_email_prompt'));
            return;
        }
        if (authState !== STATE_FORGOT && (!password || password.length < 4)) {
            alert(t('input_password_prompt'));
            return;
        }
        if (authState === STATE_SIGNUP && (!password || password.length < 4 || password !== retype)) {
            alert(t('input_retype_prompt'));
            return;
        }
        if (authState === STATE_LOGIN) {
            this.props.login(email, password);
        } else if (authState === STATE_SIGNUP) {
            this.props.register({
                username: username,
                email: email,
                password: password,
            });
        } else {
            this.props.sendResetEmail(email);
        }
    }

    render() {
        const {loggingIn, onClickClose} = this.props;
        const {authState, username, email, password, retype, remember,} = this.state;
        let btnId = 'login';
        if (authState === STATE_LOGIN) {
            btnId = 'login'
        } else if (authState === STATE_SIGNUP) {
            btnId = 'signup'
        } else if (authState === STATE_FORGOT) {
            btnId = 'send_reset_email'
        }
        
        return (
            <div className='auth-container' onClick={e=>{
                if (onClickClose) {
                    onClickClose();
                }
            }}>
                <div className='auth-layout' onClick={e=>{
                    e.stopPropagation();
                }}>
                    {/* <img src={logoImage} className='auth-icon' alt='auth' /> */}
                    <h3 className='auth-title'>{t('app_name')}</h3>
                    {authState === STATE_SIGNUP && (
                    <div className='input-item'>
                        <h4 className='input-label'>{t('username')}</h4>
                        <Input type="text" className='form-control' placeholder={t('username_placeholder')} name="username" id="username" onChange={e => {
                            this.setState({username: e.target.value});
                        }} value={username} />
                    </div>
                    )}
                    <div className='input-item'>
                        <h4 className='input-label'>{t('email')}</h4>
                        <Input type="email" className='form-control' placeholder={t('email_placeholder')} name="email" id="email" onChange={e => {
                            this.setState({email: e.target.value});
                        }} value={email} />
                    </div>
                    {authState !== STATE_FORGOT && (
                    <div className='input-item'>
                        <h4 className='input-label'>{t('password')}</h4>
                        <Input type="password" className='form-control' placeholder={t('password_placeholder')} name="password" id="password" onChange={e => {
                            this.setState({password: e.target.value});
                        }} value={password} />
                    </div>
                    )}
                    {authState === STATE_SIGNUP && (
                    <div className='input-item'>
                        <h4 className='input-label'>{t('retype')}</h4>
                        <Input type="password" className='form-control' placeholder={t('retype_placeholder')} name="retype" id="retype" onChange={e => {
                            this.setState({retype: e.target.value});
                        }} value={retype} />
                    </div>
                    )}
                    <div className='auth-switch' onClick={e=> {
                        this.setState({authState: authState !== STATE_LOGIN ? STATE_LOGIN : STATE_SIGNUP});
                    }}>
                        {t(authState !== STATE_LOGIN ? 'login' : 'signup')}
                    </div>
                    <div className='wrap-content-parent'>
                        <h4 className='input-label wrap-content-fill-child' onClick={e=> {
                            this.setState({remember: !remember})
                        }}>{remember ? <MdCheckBox /> : <MdCheckBoxOutlineBlank />} {t('remember_me')}</h4>
                        <div className='auth-switch wrap-content-wrap-child' onClick={e=> {
                            this.setState({authState: STATE_FORGOT})
                        }}>{t('forgot_password')}</div>
                    </div>
                    <div className='text-center'>
                        {loggingIn ? 
                        <Spinner size="nm" color="primary" /> :
                        <Button className='btn-auth' onClick={e=> {
                            this.onAuthAction();
                        }}>{t(btnId)}</Button>
                        }
                    </div>
                    <div style={{height: 20}} />
                </div>
            </div>
        );
    }
}

function mapState(state) {
    const { isAdmin, loggingIn, user, redirectTo, resetSuccess } = state.authentication;
    return { isAdmin, loggingIn, user, redirectTo, resetSuccess };
}

const actionCreators = {
    login: userActions.login,
    register: userActions.register,
    logout: userActions.logout,
    initResetFlag: userActions.initResetFlag,
    setAuthRedirect: userActions.setAuthRedirect,
    sendResetEmail: userActions.sendResetEmail,
};

const connectedLandingNav = connect(mapState, actionCreators)(AuthForm);
export { connectedLandingNav as AuthForm };
